
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 48 48","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-fill",attrs:{"d":"m6.848 16.286 6.449 5.964h16.397v-12H13.297l-.065.072-6.384 5.964ZM26.67 36.85l6.448-5.964-6.449-6.036H11.272v12h15.397Z","fill":"#D0EFEC"}}),_c('circle',{staticClass:"i-circle",attrs:{"cx":"24","cy":"24","r":"20.62","stroke":"#234652"}}),_c('path',{staticClass:"i-signs",attrs:{"d":"M27.23 34.844h5.894l4.175-4.052-4.175-4.052H14.557v8.104h9.413v3.966m-.022-29.556v2.996m0 8.301v5.796m-3.153 12.909h6.336M14.951 12.25h18.566v8.105H14.95l-4.175-4.053 4.175-4.052Z","stroke":"#234652"}})])
          )
        }
      }
    